import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
function Title({
    title, icon, before, className, iconClassName, alignment, padding, margin, subtitle, subtitlePadding, subtitleMargin, sectionTitle,
})
{
    return (
        <div>
            <div
                data-section-title={sectionTitle}
                className={`tw-font-title tw-flex tw-gap-3 tw-font-bold tw-text-2xl tw-text-neutral-darkestest ${className} ${margin} ${alignment}
            ${before ? `tw-relative ${padding} tw-ml-3 before:tw-rounded-md before:tw-content-[""] before:tw-absolute before:tw-left-[-12px] before:tw-top-0 before:tw-w-1 before:tw-h-[250%] before:tw-bg-primary-default` : ''}

                    `}
            >
                { icon && (<FontAwesomeIcon className={iconClassName} icon={icon} />)} {title}
            </div>
            {subtitle
            && <div className={`${subtitlePadding ?? padding} ${subtitleMargin ?? margin}`}>{subtitle}</div>}
        </div>
    );
}

Title.defaultProps = {
    margin: 'tw-mt-5 tw-mb-3',
    padding: 'tw-pt-5 tw-pl-5',
    before: false,
    subtitle: '',
    className: '',
    iconClassName: '',
    alignment: 'tw-items-center',
};

Title.propTypes = {
    title: PropTypes.string.isRequired,
    className: PropTypes.string,
    subtitle: PropTypes.string,
    iconClassName: PropTypes.string,
    subtitlePadding: PropTypes.string,
    subtitleMargin: PropTypes.string,
    margin: PropTypes.string,
    padding: PropTypes.string,
    icon: PropTypes.object,
    before: PropTypes.bool,
    alignment: PropTypes.string,
};

export default Title;
